import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9b98c8be")

_pushScopeId("data-v-9b98c8be")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "pa-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_empty = _resolveComponent("van-empty")
  const _component_score_analyse = _resolveComponent("score-analyse")
  const _component_deduct = _resolveComponent("deduct")
  const _component_sleep_curve = _resolveComponent("sleep-curve")
  const _component_snore_level = _resolveComponent("snore-level")
  const _component_heart_rate = _resolveComponent("heart-rate")
  const _component_breath_rate = _resolveComponent("breath-rate")
  const _component_turn_over = _resolveComponent("turn-over")
  const _component_temperature = _resolveComponent("temperature")
  const _component_humidity = _resolveComponent("humidity")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.emptyMessage)
        ? (_openBlock(), _createBlock(_component_van_empty, {
            key: 0,
            image: "error",
            description: _ctx.emptyMessage
          }, null, 8, ["description"]))
        : _createCommentVNode("", true),
      (_ctx.item)
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            (_ctx.item.analysis.reportFlag === 1)
              ? (_openBlock(), _createBlock(_component_score_analyse, {
                  key: 0,
                  "curr-date": _ctx.item.date,
                  analysis: _ctx.item.analysis,
                  summary: _ctx.item.summary,
                  class: "mt-2"
                }, null, 8, ["curr-date", "analysis", "summary"]))
              : (_ctx.item.analysis.reportFlag === 2)
                ? (_openBlock(), _createBlock(_component_score_analyse, {
                    key: 1,
                    "curr-date": _ctx.currDate,
                    analysis: _ctx.item.analysis,
                    summary: _ctx.item.summary,
                    class: "mt-2"
                  }, null, 8, ["curr-date", "analysis", "summary"]))
                : _createCommentVNode("", true),
            _createVNode("div", null, [
              (_ctx.item.analysis.reportFlag === 1)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_deduct, {
                      analysis: _ctx.item.analysis
                    }, null, 8, ["analysis"]),
                    (
                _ctx.item.analysis.sleepCurveArray &&
                  _ctx.item.analysis.sleepCurveArray.length
              )
                      ? (_openBlock(), _createBlock(_component_sleep_curve, {
                          key: 0,
                          "y-axis": _ctx.item.analysis.sleepCurveArray,
                          "start-time": _ctx.item.summary.startTime,
                          "deep-sleep-perc": _ctx.item.analysis.deepSleepPerc,
                          "in-sleep-perc": _ctx.item.analysis.inSleepPerc,
                          "light-sleep-perc": _ctx.item.analysis.lightSleepPerc,
                          "wake-sleep-perc": _ctx.item.analysis.wakeSleepPerc
                        }, null, 8, ["y-axis", "start-time", "deep-sleep-perc", "in-sleep-perc", "light-sleep-perc", "wake-sleep-perc"]))
                      : _createCommentVNode("", true),
                    (
                _ctx.item.analysis.snore_number && _ctx.item.analysis.snore_level?.length
              )
                      ? (_openBlock(), _createBlock(_component_snore_level, {
                          key: 1,
                          "y-axis": _ctx.item.analysis.snore_level,
                          "start-time": _ctx.item.summary.startTime,
                          snore_high_proportion: _ctx.item.analysis.snore_non_proportion,
                          snore_low_proportion: _ctx.item.analysis.snore_low_proportion,
                          snore_mid_proportion: _ctx.item.analysis.snore_mid_proportion,
                          snore_non_proportion: _ctx.item.analysis.snore_high_proportion,
                          snore_duration: _ctx.item.analysis.snore_duration,
                          snore_number: _ctx.item.analysis.snore_number
                        }, null, 8, ["y-axis", "start-time", "snore_high_proportion", "snore_low_proportion", "snore_mid_proportion", "snore_non_proportion", "snore_duration", "snore_number"]))
                      : _createCommentVNode("", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("", true),
              _createVNode(_component_heart_rate, {
                "y-axis": _ctx.item.detail.heartRate,
                "start-time": _ctx.item.summary.startTime,
                "average-heart-beat-rate": _ctx.item.analysis.averageHeartBeatRate
              }, null, 8, ["y-axis", "start-time", "average-heart-beat-rate"]),
              _createVNode(_component_breath_rate, {
                "average-breath-rate": _ctx.item.analysis.averageBreathRate,
                "y-axis": _ctx.item.detail.breathRate,
                "start-time": _ctx.item.summary.startTime
              }, null, 8, ["average-breath-rate", "y-axis", "start-time"]),
              _createVNode(_component_turn_over, {
                "y-axis": _ctx.item.analysis.turnOverStatusAry,
                "start-time": _ctx.item.summary.startTime
              }, null, 8, ["y-axis", "start-time"]),
              (_ctx.item.detail.etemp && _ctx.item.detail.etemp.length)
                ? (_openBlock(), _createBlock(_component_temperature, {
                    key: 1,
                    "y-axis": _ctx.item.detail.etemp,
                    "start-time": _ctx.item.summary.startTime
                  }, null, 8, ["y-axis", "start-time"]))
                : _createCommentVNode("", true),
              (_ctx.item.detail.ehumidity && _ctx.item.detail.ehumidity.length)
                ? (_openBlock(), _createBlock(_component_humidity, {
                    key: 2,
                    "y-axis": _ctx.item.detail.ehumidity,
                    "start-time": _ctx.item.summary.startTime
                  }, null, 8, ["y-axis", "start-time"]))
                : _createCommentVNode("", true)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("", true)
    ])
  ]))
})